import { useEffect, useState } from 'react';

/** Restituisce `valore` dopo `ritardo` ms senza modifiche (per la ricerca lato server). */
export const useDebouncedValue = (valore, ritardo = 350) => {
  const [debounced, setDebounced] = useState(valore);

  useEffect(() => {
    const t = setTimeout(() => setDebounced(valore), ritardo);
    return () => clearTimeout(t);
  }, [valore, ritardo]);

  return debounced;
};
